import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import BtnIcons from '../../../../api/images/btnIcons';
import {getEventState} from "../../../../constants/event"
import { JUST_NOW_DATE_TIMES } from '../../../../constants/base';
import Notification from '../../../../components/Notification/Notification';
import {
  basicMissionInfoAddBudgetRequest,
  basicMissionInfoDepositRequest,
  basicMissionInfoDetailRequest,
  basicMissionInfoUpdateRequest,
} from '../../../../redux/actions/app/basicActions';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import { CondDateTimePicker, Visible } from '../../../../components';
import { InitialEventState } from '../../../../constants/event';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import walletConnect from '../../../../api/wallet/walletConnect';
import useApproveEvent from '../../../../api/wallet/approveEvent';
import changeNumApi from '../../../../api/ui/changeNumApi';

function basicMissionInfo(props) {
  // -- props --//
  const { missionNo, readOnly } = props?.location?.state;

  // -- component const --//
  const title = '상세 정보';
  const { connectWallet } = walletConnect();
  const approveEvent = useApproveEvent();
  let txHash = null;
  let transactionResult = false;

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const [detailData, setDetailData] = useState(null);
  const [state, setState] = useState(null);

  // 설정
  const [beginAt, setBeginAt] = useState();
  const [endAt, setEndAt] = useState();
  const [conditionAt, setConditionAt] = useState();
  const [addPer, setAddPer] = useState(0);
  const [dailyMission, setDailyMission] = useState('');
  const [achieveMission, setAchieveMission] = useState('');

  const [approvePerBtnDisabled, setApprovePerBtnDisabled] = useState(false);
  const [addPerBtnDisabled, setAddPerBtnDisabled] = useState(false);

  // -- func & handler --//
  const fetchData = () => {
    dispatch(
      basicMissionInfoDetailRequest({
        missionNo: missionNo,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setDetailData(data);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    );
  }

  const handleConnect = async () => {
    await connectWallet();
  };


  const handleApproveEvent = async (token) => {
    console.log(token);

    token === 'PER' ? setApprovePerBtnDisabled(true) : setAddPerBtnDisabled(true);

    if (!window.havah) {
      alert('지갑 연동을 먼저 해주세요!');
      await connectWallet();
    }

    const walletAddr = detailData?.walletAddress;
    const initialTokenValue = () => {
      if (token === 'PER') {
        return  detailData?.initialPer;
      } else {
        return  parseFloat(changeNumApi.mul18(addPer));
      }
    };

    console.log(token, walletAddr, initialTokenValue());

    const {
      txHash: resultTxHash,
      transactionResult: resultTransactionResult,
      res: res,
    } = await approveEvent(token, walletAddr, initialTokenValue());

    // approveEvent 함수에서 반환된 값 출력
    console.log('txHash:', resultTxHash);
    console.log('transactionResult:', resultTransactionResult);

    // txHash와 transactionResult를 변수에 할당 (필요하다면 다른 곳에서 사용할 수 있음)
    txHash = resultTxHash;
    transactionResult = resultTransactionResult;

    if (transactionResult) {
      console.log('transactionResult 전송');
      token === 'XPER' || token === 'PER'
        ? dispatch(basicMissionInfoDepositRequest({
          missionNo: detailData?.missionNo,
          tokenType: token === 'PER' ? 1 : 2,
          transactionHash: txHash,
          callback: (data) => {
            console.log('요청 결과: ', data);
            setNotificationMessage('이벤트 승인 성공');
            setShowNotification(true);
            setApprovePerBtnDisabled(false);

            setTimeout(() => {
              // 1초 후 정보 갱신
              fetchData();
            }, 1000);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);
            setApprovePerBtnDisabled(false);
          },
        }))
        : token === 'ADDXPER' || token === 'ADDPER'
          ? dispatch(basicMissionInfoAddBudgetRequest({
            missionNo: detailData?.missionNo,
            addXper: 0,
            addPer: parseFloat(changeNumApi.mul18(addPer)),
            transactionHash: txHash,
            callback: (data) => {
              console.log('요청 결과: ', data);
              setNotificationMessage('예산 추가 성공');
              setShowNotification(true);
              setAddPerBtnDisabled(false);

              setAddPer(0);

              setTimeout(() => {
                // 1초 후 정보 갱신
                fetchData();
              }, 1000);
            },
            error: (e) => {
              console.log(e);
              setNotificationMessage(e.toString());
              setShowNotification(true);
            },
          }))
          : alert('확인 필요');
    } else {
      token === 'PER' ? setApprovePerBtnDisabled(false) : setAddPerBtnDisabled(false);
      setNotificationMessage(`사유: ${res.type}로 실패했습니다.`);
      setShowNotification(true);
    }

  };

  const handleOnClickStop = () => {
    dispatch(
      basicMissionInfoUpdateRequest({
        missionNo: detailData?.missionNo,
        beginAt: beginAt,
        endAt: JUST_NOW_DATE_TIMES?.value, // 페이지 진입 한 시간으로 종료
        conditionAt: conditionAt,
        dailyData: dailyMission,
        achievementData: achieveMission,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setNotificationMessage('미션 종료 요청 성공');
          setShowNotification(true);

          setTimeout(() => {
            // 1초 후 정보 갱신
            fetchData();
          }, 1000);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    );
  };

  const handleOnClickSave = () => {
    dispatch(
      basicMissionInfoUpdateRequest({
        missionNo: detailData?.missionNo,
        beginAt: beginAt,
        endAt: endAt,
        conditionAt: conditionAt,
        dailyData: dailyMission,
        achievementData: achieveMission,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setNotificationMessage('미션 정보 업데이트 요청 성공');
          setShowNotification(true);

          setTimeout(() => {
            // 1초 후 정보 갱신
            fetchData();
          }, 1000);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      })
    );

  };

  // -- react hooks --//
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // 상세정보 받아온 뒤 값 설정
    setState(getEventState({
      startAt: detailData?.beginAt,
      endAt: detailData?.endAt,
      depositTransactionStatus : detailData?.depositTransactionStatus
    }));
    setBeginAt(timeFormAPI.changeDataLog(detailData?.beginAt));
    setEndAt(timeFormAPI.changeDataLog(detailData?.endAt));
    setConditionAt(timeFormAPI.changeDataLog(detailData?.conditionAt));
    setDailyMission(detailData?.dailyData);
    setAchieveMission(detailData?.achievementData);
  }, [detailData])

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <div className="topSectionBack">
        <img
          src={BtnIcons.backIcon}
          className="backIcon"
          onClick={() => {
            window.history.back();
          }}
          alt="goBack"
        />
        <p className="titleText">{title}</p>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea paddingAll">
        <div className="rowDiv flex" style={{ alignItems: 'center' }}>
          <div className="leftDiv">미션 번호</div>
          <div className="rightDiv">
            {detailData?.missionNo}
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex" style={{ alignItems: 'center' }}>
          <div className="leftDiv">상태</div>
          <div className="rightDiv">
            {state}
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex" style={{ alignItems: 'center' }}>
          <div className="leftDiv">미션 기간</div>
          <div className="rightDiv date">
            <CondDateTimePicker
              disable={
                state === InitialEventState.InProgress ||
                state === InitialEventState.CancelEvent ||
                state === InitialEventState.DeleteEvent ||
                state === InitialEventState.BudgetExhausted ||
                state === InitialEventState.Finished
              }
              value={beginAt}
              onChange={(date) => setBeginAt(date.format('YYYY-MM-DDTHH:mm'))}
            />
            부터
            <CondDateTimePicker
              disable={
                state === InitialEventState.CancelEvent ||
                state === InitialEventState.DeleteEvent ||
                state === InitialEventState.BudgetExhausted ||
                state === InitialEventState.Finished
              }
              value={endAt}
              onChange={(date) => setEndAt(date.format('YYYY-MM-DDTHH:mm'))}
            />
            까지
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex" style={{ alignItems: 'center' }}>
          <div className="leftDiv">일일 미션 시작 일시</div>
          <div className="rightDiv date">
            <CondDateTimePicker
              disable={
                state === InitialEventState.CancelEvent ||
                state === InitialEventState.DeleteEvent ||
                state === InitialEventState.BudgetExhausted ||
                state === InitialEventState.Finished
              }
              value={conditionAt}
              onChange={(date) => setConditionAt(date.format('YYYY-MM-DDTHH:mm'))}
            />
            <div className="" style={{
              fontSize: 10,
              color: '#E90A32',
              alignContent: 'center'
            }}>
              * 해당 일자와 유저의 가입일 중 늦은 쪽이 일일 미션 오픈 판단의 기준 날짜가 됩니다.
            </div>
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div className="rowDiv flex" style={{ alignItems: 'center', gap: 50 }}>
          <div>
              일일 미션 내용(JSON)
            <div className="spaceDiv10"/>
            <textarea
                style={{
                  width: '30vw',
                  height: '50vh',
                  fontFamily: 'monospace', // 고정폭 폰트 사용
                }}
              value={dailyMission}
              onChange={(e) => {
                setDailyMission(e.target.value.toString());
              }}
              placeholder={dailyMission}
              disabled={readOnly}
            />
          </div>

          <div>
            업적 미션 내용(JSON)
            <div className="spaceDiv10"/>
            <textarea
                style={{
                  width: '30vw',
                  height: '50vh',
                  fontFamily: 'monospace', // 고정폭 폰트 사용
                }}
              value={achieveMission}
              onChange={(e) => {
                setAchieveMission(e.target.value.toString());
              }}
              placeholder={achieveMission}
              disabled={readOnly}
            />
          </div>
        </div>
      </div>

      <div className="spaceDiv10"/>

      {/* 하단 버튼 영역 */}
      <Visible visible={state !== InitialEventState.Finished}>
        <div className="betweenBtn">
          <div className="leftBtn">
            <Visible visible={
              state === InitialEventState.DepositWaiting ||
              state === InitialEventState.Waiting
            }>
              <button
                className="defaultBtn error"
                disabled={readOnly}
                // onClick={handleOnClickDelete}
                onClick={handleOnClickStop}
              >
                {/* 이벤트 삭제 */}
                이벤트 즉시 종료
              </button>
            </Visible>
            <Visible visible={state === InitialEventState.InProgress}>
              <button
                className="defaultBtn error"
                disabled={readOnly}
                onClick={handleOnClickStop}
              >
                이벤트 즉시 종료
              </button>
            </Visible>
          </div>
          <div className="rightBtn">
            <Visible
              visible={
                state === InitialEventState.DepositWaiting ||
                state === InitialEventState.Waiting ||
                state === InitialEventState.InProgress
              }
            >
              <button
                className="defaultBtn"
                disabled={readOnly}
                onClick={handleOnClickSave}
              >
                변경사항 저장
              </button>
            </Visible>
          </div>
        </div>
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  )
}

export default basicMissionInfo;
